// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buy-token {
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
  flex-direction: row;
  margin-top: 1.5rem !important;
  flex-wrap: nowrap !important; }
  .buy-token__left {
    align-items: center;
    color: #ffffff; }
  .buy-token__left-title {
    font-family: "Outfit", sans-serif;
    font-size: 48px;
    font-weight: 600; }
  .buy-token__left-subtitle {
    font-family: "Outfit", sans-serif;
    font-size: 16px;
    font-weight: 400; }
  .buy-token__right {
    margin-top: 1.25rem;
    padding: 20px;
    border-radius: 20px;
    background-color: rgba(43, 7, 77, 0.85);
    box-shadow: 0 0 14px 0 #ff2481;
    min-height: 390px;
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center; }
  .buy-token__right-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    gap: 15px;
    padding: 20px; }
    .buy-token__right-wrapper button {
      background-color: #ff2481;
      color: #ffffff;
      padding: 0.5em 1em;
      border: 1.85px solid #e02574;
      cursor: pointer;
      border-radius: 6px;
      width: 100%;
      border-radius: 12px;
      height: 50px;
      margin-bottom: 1rem; }
      .buy-token__right-wrapper button:hover {
        background-color: #e02574; }
  .buy-token__exchangeBox {
    display: flex;
    border-radius: 8px;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background-color: #ffffff;
    color: #2b074d;
    margin-bottom: 1px; }
    .buy-token__exchangeBox input {
      width: 100px;
      background-color: #ededed;
      border: none;
      padding: 5px;
      border-radius: 6px;
      text-align: center; }
    .buy-token__exchangeBox input:focus-within {
      box-shadow: 0 0 14px 0 #ff2481; }
    .buy-token__exchangeBox input:focus::placeholder {
      color: transparent; }
  .buy-token__exchangeRate {
    width: 100%;
    border-radius: 12px;
    color: #ffffff;
    background-color: #757179;
    height: 48px;
    align-items: center;
    display: flex;
    padding: 10px 12px; }
  .buy-token__iconWrapper {
    position: relative;
    height: 5px;
    display: flex;
    justify-content: center;
    align-items: center; }
  .buy-token__icon {
    position: absolute;
    border-radius: 8px;
    bottom: -20px;
    z-index: 2;
    background-color: #ffffff;
    color: #ff2481;
    padding: 10px;
    border: 5px solid #2b074d; }
  .buy-token__currencyWrapper {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 36px;
    color: #2b074d;
    font-family: "Outfit", sans-serif;
    font-size: 16px;
    font-weight: 700;
    background-color: #ededed;
    border-radius: 18px; }
  .buy-token__modal {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px; }
  .buy-token__modalTitle {
    font-family: "Outfit", sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #2b074d; }
  .buy-token__activeCurrencyAmout {
    justify-content: center;
    font-family: "Outfit", sans-serif;
    font-size: 24px;
    font-weight: 600;
    width: 50%;
    text-align: center;
    color: #2b074d;
    background-color: #ededed;
    border-radius: 20px;
    padding: 10px;
    display: flex;
    align-items: center; }
  .buy-token__modalSubtitle {
    font-family: "Outfit", sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #2b074d; }
  .buy-token__walletAddress {
    display: flex;
    gap: 20px;
    padding: 5px 10px;
    border-radius: 6px;
    align-items: center;
    font-family: "Outfit", sans-serif;
    font-size: 20px;
    font-weight: 600;
    background-color: #2b074d;
    color: #ffffff; }
  .buy-token__iconCopy {
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer !important; }
  .buy-token__submitBtn {
    border: none !important;
    background-color: #ff2481 !important;
    width: 200px;
    transition: all 0.3s ease-in-out; }
    .buy-token__submitBtn:hover {
      background-color: #ff2481 !important;
      box-shadow: 0 0 14px 0 #ff2481; }

.modal-content {
  min-width: 600px !important; }

@media (max-width: 997px) {
  .buy-token {
    flex-direction: column;
    margin-bottom: 2rem; }
    .buy-token__left {
      width: 100%;
      margin-bottom: 1rem; }
    .buy-token__right {
      width: 100%; }
    .buy-token__left-title {
      font-family: "Outfit", sans-serif;
      font-size: 36px;
      font-weight: 600; }
    .buy-token__walletAddress {
      font-size: 12px; }
  .modal-content {
    min-width: 200px !important; } }

input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none; }
`, "",{"version":3,"sources":["webpack://./src/styles/pages/buytoken.scss","webpack://./src/styles/variables/_variables.scss","webpack://./src/styles/mixins/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B,EAAA;EAC5B;IACE,mBAAmB;IACnB,cCTqB,EAAA;EDWvB;IEbE,iCAAiC;IACjC,eFa4B;IEZ5B,gBFYiC,EAAA;EAEnC;IEhBE,iCAAiC;IACjC,eFgB4B;IEf5B,gBFeiC,EAAA;EAGnC;IEdE,mBAAmB;IACnB,aAAa;IACb,mBDOuB;ICNvB,uCDT0B;ICU1B,8BDEqC;ICDrC,iBFU2B;IAC3B,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAA;EAGrB;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,SAAS;IACT,aAAa,EAAA;IAPd;MEbC,yBDKgC;MCJhC,cDdqB;MCerB,kBAAkB;MAClB,4BDC4B;MCA5B,eAAe;MACf,kBAAkB;MFmBhB,WAAW;MACX,mBAAmB;MACnB,YAAY;MACZ,mBAAmB,EAAA;MAdtB;QELK,yBDFuB,EAAA;EDyB7B;IACE,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,yBCnDqB;IDoDrB,cCtD0B;IDuD1B,kBAAkB,EAAA;IATnB;MAYG,YAAY;MACZ,yBCnCuB;MDoCvB,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,kBAAkB,EAAA;IAjBrB;MAoBG,8BCtDmC,EAAA;IDkCtC;MAuBG,kBAAkB,EAAA;EAItB;IACE,WAAW;IACX,mBAAmB;IACnB,cC1EqB;ID2ErB,yBCzE2B;ID0E3B,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,kBAAkB,EAAA;EAGpB;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;EAGrB;IACE,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,yBC/FqB;IDgGrB,cC9EgC;ID+EhC,aAAa;IACb,yBCpG0B,EAAA;EDuG5B;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,cC9G0B;ICA1B,iCAAiC;IACjC,eF8G4B;IE7G5B,gBF6GiC;IACjC,yBCxFyB;IDyFzB,mBAAmB,EAAA;EAGrB;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAA;EAGX;IE5HE,iCAAiC;IACjC,eF4H4B;IE3H5B,gBF2HiC;IACjC,cC9H0B,EAAA;EDiI5B;IACE,uBAAuB;IElIvB,iCAAiC;IACjC,eFkI4B;IEjI5B,gBFiIiC;IACjC,UAAU;IACV,kBAAkB;IAClB,cCtI0B;IDuI1B,yBC/GyB;IDgHzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB,EAAA;EAGrB;IE9IE,iCAAiC;IACjC,eF8I4B;IE7I5B,gBF6IiC;IACjC,cChJ0B,EAAA;EDmJ5B;IACE,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IExJnB,iCAAiC;IACjC,eFwJ4B;IEvJ5B,gBFuJiC;IACjC,yBC1J0B;ID2J1B,cCzJqB,EAAA;ED4JvB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B,EAAA;EAG5B;IACE,uBAAuB;IACvB,oCAAwD;IACxD,YAAY;IACZ,gCAAgC,EAAA;IAJjC;MAMG,oCAAwD;MACxD,8BC/JmC,EAAA;;ADoKzC;EACE,2BAA2B,EAAA;;AAG7B;EACE;IACE,sBAAsB;IACtB,mBAAmB,EAAA;IACnB;MACE,WAAW;MACX,mBAAmB,EAAA;IAErB;MACE,WAAW,EAAA;IAEb;ME/LA,iCAAiC;MACjC,eF+L8B;ME9L9B,gBF8LmC,EAAA;IAEnC;MACE,eAAe,EAAA;EAGnB;IACE,2BAA2B,EAAA,EAC5B;;AAGH;EACE,wBAAwB,EAAA","sourcesContent":["@import \"../variables/variables\";\n@import \"../mixins/mixins\";\n.buy-token {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  align-items: center;\n  flex-direction: row;\n  margin-top: 1.5rem !important;\n  flex-wrap: nowrap !important;\n  &__left {\n    align-items: center;\n    color: $tokenWhiteColor;\n  }\n  &__left-title {\n    @include tokenFontMixin(48px, 600);\n  }\n  &__left-subtitle {\n    @include tokenFontMixin(16px, 400);\n  }\n\n  &__right {\n    @include tokenSection(390px);\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  &__right-wrapper {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    gap: 15px;\n    padding: 20px;\n\n    & button {\n      @include tokenMainButton($tokenWhiteColor, $tokenButtonBackgroundColor);\n      width: 100%;\n      border-radius: 12px;\n      height: 50px;\n      margin-bottom: 1rem;\n    }\n  }\n\n  &__exchangeBox {\n    display: flex;\n    border-radius: 8px;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px;\n    background-color: $tokenWhiteColor;\n    color: $tokenBackgroundColor;\n    margin-bottom: 1px;\n\n    & input {\n      width: 100px;\n      background-color: $tokenCoinBackground;\n      border: none;\n      padding: 5px;\n      border-radius: 6px;\n      text-align: center;\n    }\n    & input:focus-within {\n      box-shadow: $tokenContainerShadow;\n    }\n    input:focus::placeholder {\n      color: transparent;\n    }\n  }\n\n  &__exchangeRate {\n    width: 100%;\n    border-radius: 12px;\n    color: $tokenWhiteColor;\n    background-color: $tokenPlaceholderColor;\n    height: 48px;\n    align-items: center;\n    display: flex;\n    padding: 10px 12px;\n  }\n\n  &__iconWrapper {\n    position: relative;\n    height: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &__icon {\n    position: absolute;\n    border-radius: 8px;\n    bottom: -20px;\n    z-index: 2;\n    background-color: $tokenWhiteColor;\n    color: $tokenButtonBackgroundColor;\n    padding: 10px;\n    border: 5px solid $tokenBackgroundColor;\n  }\n\n  &__currencyWrapper {\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    height: 36px;\n    color: $tokenBackgroundColor;\n    @include tokenFontMixin(16px, 700);\n    background-color: $tokenCoinBackground;\n    border-radius: 18px;\n  }\n\n  &__modal {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n  }\n\n  &__modalTitle {\n    @include tokenFontMixin(24px, 600);\n    color: $tokenBackgroundColor;\n  }\n\n  &__activeCurrencyAmout {\n    justify-content: center;\n    @include tokenFontMixin(24px, 600);\n    width: 50%;\n    text-align: center;\n    color: $tokenBackgroundColor;\n    background-color: $tokenCoinBackground;\n    border-radius: 20px;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n  }\n\n  &__modalSubtitle {\n    @include tokenFontMixin(18px, 600);\n    color: $tokenBackgroundColor;\n  }\n\n  &__walletAddress {\n    display: flex;\n    gap: 20px;\n    padding: 5px 10px;\n    border-radius: 6px;\n    align-items: center;\n    @include tokenFontMixin(20px, 600);\n    background-color: $tokenBackgroundColor;\n    color: $tokenWhiteColor;\n  }\n\n  &__iconCopy{\n    margin-top: 10px;\n    margin-bottom: 10px;\n    cursor: pointer !important;\n  }\n\n  &__submitBtn {\n    border: none !important;\n    background-color: $tokenButtonBackgroundColor !important;\n    width: 200px;\n    transition: all 0.3s ease-in-out;\n    &:hover {\n      background-color: $tokenButtonBackgroundColor !important;\n      box-shadow: $tokenContainerShadow;\n    }\n  }\n}\n\n.modal-content {\n  min-width: 600px !important;\n}\n\n@media (max-width: 997px) {\n  .buy-token {\n    flex-direction: column;\n    margin-bottom: 2rem;\n    &__left {\n      width: 100%;\n      margin-bottom: 1rem;\n    }\n    &__right {\n      width: 100%;\n    }\n    &__left-title {\n      @include tokenFontMixin(36px, 600);\n    }\n    &__walletAddress {\n      font-size: 12px;\n    }\n  }\n  .modal-content {\n    min-width: 200px !important;\n  }\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n","// Main Colors\n$tokenBackgroundColor: #2b074d;\n$tokenContainerBackgroundColor: rgba($tokenBackgroundColor, 0.85);\n$tokenWhiteColor: #ffffff;\n$tokenBlackColor: #000000;\n$tokenPlaceholderColor: #757179;\n\n// Status Colors\n$tokenVerifyStatus: #60ffa8;\n$tokenPendingStatus: #ffdb81;\n$tokenErrorStatus: #ff0000;\n\n// SHADOW\n$tokenContainerShadow: 0 0 14px 0 #ff2481;\n\n// BORDER\n$tokenContainerRadius: 20px;\n$tokenContainerBorderColor: #340c5a;\n\n// BUTTON\n$tokenButtonBorderColor: #e02574;\n$tokenButtonBackgroundColor: #ff2481;\n$tokenButtonHoverColor: #e02574;\n\n// COIN BACKGROUND\n$tokenCoinBackground: #ededed;\n","@mixin tokenFontMixin($fontSize, $fontWeight) {\n    font-family: \"Outfit\", sans-serif;\n    font-size: $fontSize;\n    font-weight: $fontWeight;\n}\n\n@mixin tokenSection($height) {\n    margin-top: 1.25rem;\n    padding: 20px;\n    border-radius: $tokenContainerRadius;\n    background-color: $tokenContainerBackgroundColor;\n    box-shadow: $tokenContainerShadow;\n    min-height: $height;\n}\n\n@mixin tokenMainButton($color, $backgroundColor) {\n    background-color: $backgroundColor;\n    color: $color;\n    padding: 0.5em 1em;\n    border: 1.85px solid $tokenButtonBorderColor;\n    cursor: pointer;\n    border-radius: 6px;\n\n    &:hover {\n        background-color: $tokenButtonHoverColor;\n    }\n}\n\n@mixin tokenOutlineButton($color, $backgroundColor) {\n    background-color: $backgroundColor;\n    color: $color;\n    padding: 0.5em 1em;\n    border: 2px solid $tokenButtonBackgroundColor;\n    cursor: pointer;\n    border-radius: 6px;\n\n    &:hover {\n        background-color: $tokenButtonHoverColor;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
